{
    "name": "Voron",
    "version": "01.10.00.01",
    "force_update": "0",
    "description": "Voron configurations",
    "machine_model_list": [
        {
            "name": "Voron 2.4 250",
            "sub_path": "machine/Voron 2.4 250.json"
        },
        {
            "name": "Voron 2.4 300",
            "sub_path": "machine/Voron 2.4 300.json"
        },
        {
            "name": "Voron 2.4 350",
            "sub_path": "machine/Voron 2.4 350.json"
        },
        {
            "name": "Voron Trident 250",
            "sub_path": "machine/Voron Trident 250.json"
        },
        {
            "name": "Voron Trident 300",
            "sub_path": "machine/Voron Trident 300.json"
        },
        {
            "name": "Voron Trident 350",
            "sub_path": "machine/Voron Trident 350.json"
        },
        {
            "name": "Voron 0.1",
            "sub_path": "machine/Voron 0.1.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "fdm_process_voron_common",
            "sub_path": "process/fdm_process_voron_common.json"
        },
        {
            "name": "0.08mm Extra Fine @Voron",
            "sub_path": "process/0.08mm Extra Fine @Voron.json"
        },
        {
            "name": "0.12mm Fine @Voron",
            "sub_path": "process/0.12mm Fine @Voron.json"
        },
        {
            "name": "0.15mm Optimal @Voron",
            "sub_path": "process/0.15mm Optimal @Voron.json"
        },
        {
            "name": "0.20mm Standard @Voron",
            "sub_path": "process/0.20mm Standard @Voron.json"
        },
        {
            "name": "0.24mm Draft @Voron",
            "sub_path": "process/0.24mm Draft @Voron.json"
        },
        {
            "name": "0.28mm Extra Draft @Voron",
            "sub_path": "process/0.28mm Extra Draft @Voron.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Generic ABS @Voron",
            "sub_path": "filament/Generic ABS @Voron.json"
        },
        {
            "name": "Generic ASA @Voron",
            "sub_path": "filament/Generic ASA @Voron.json"
        },
        {
            "name": "Generic PA @Voron",
            "sub_path": "filament/Generic PA @Voron.json"
        },
        {
            "name": "Generic PA-CF @Voron",
            "sub_path": "filament/Generic PA-CF @Voron.json"
        },
        {
            "name": "Generic PC @Voron",
            "sub_path": "filament/Generic PC @Voron.json"
        },
        {
            "name": "Generic PETG @Voron",
            "sub_path": "filament/Generic PETG @Voron.json"
        },
        {
            "name": "Generic PLA @Voron",
            "sub_path": "filament/Generic PLA @Voron.json"
        },
        {
            "name": "Generic PLA-CF @Voron",
            "sub_path": "filament/Generic PLA-CF @Voron.json"
        },
        {
            "name": "Generic PVA @Voron",
            "sub_path": "filament/Generic PVA @Voron.json"
        },
        {
            "name": "Generic TPU @Voron",
            "sub_path": "filament/Generic TPU @Voron.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "fdm_klipper_common",
            "sub_path": "machine/fdm_klipper_common.json"
        },
        {
            "name": "Voron 2.4 250 0.4 nozzle",
            "sub_path": "machine/Voron 2.4 250 0.4 nozzle.json"
        },
        {
            "name": "Voron 2.4 300 0.4 nozzle",
            "sub_path": "machine/Voron 2.4 300 0.4 nozzle.json"
        },
        {
            "name": "Voron 2.4 350 0.4 nozzle",
            "sub_path": "machine/Voron 2.4 350 0.4 nozzle.json"
        },
        {
            "name": "Voron Trident 250 0.4 nozzle",
            "sub_path": "machine/Voron Trident 250 0.4 nozzle.json"
        },
        {
            "name": "Voron Trident 300 0.4 nozzle",
            "sub_path": "machine/Voron Trident 300 0.4 nozzle.json"
        },
        {
            "name": "Voron Trident 350 0.4 nozzle",
            "sub_path": "machine/Voron Trident 350 0.4 nozzle.json"
        },
        {
            "name": "Voron 0.1 0.4 nozzle",
            "sub_path": "machine/Voron 0.1 0.4 nozzle.json"
        }
    ]
}
